var escape = require("../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".YsiADIIXr0 {\n  position: relative;\n  padding: 30px 0; }\n  .YsiADIIXr0 ._1hqFsGi2uB {\n    display: block;\n    margin: 0 auto;\n    width: 32px;\n    height: 8px;\n    background: url(" + escape(require("../../pc/public/img/sw/loader_square_32x8_green.gif")) + ") no-repeat; }\n  .YsiADIIXr0.fyX0qJ_Irt {\n    padding: 200px 0; }\n", ""]);

// exports
exports.locals = {
	"loader": "YsiADIIXr0",
	"ico_loading": "_1hqFsGi2uB",
	"full": "fyX0qJ_Irt"
};